import { z } from 'zod';

export const RewardDtoSchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
  sweepCoin: z.number(),
  goldCoin: z.number(),
  bonusSweepCoin: z.number(),
  rewardRuleId: z.string().uuid(),
  order: z.number(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
});

export const RewardSchema = z.object({
  id: z.string().uuid(),
  userId: z.string().uuid(),
  reward: RewardDtoSchema,
  idempotencyKey: z.string(),
  cycle: z.number(),
  claimedAt: z.string().datetime().nullable(),
  startsAt: z.string().datetime(),
  endsAt: z.string().datetime(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
});

export const RewardRuleSchema = z.object({
  name: z.string(),
  description: z.string().nullable(),
  type: z.literal('daily-bonus'),
  isActive: z.boolean(),
  config: z.string(),
  priority: z.number(),
});

export const GroupedRewardSchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
  description: z.string().nullable(),
  type: z.enum(['daily-bonus', 'bundle-bonus']),
  priority: z.number(),
  amount: z.number(),
  startsAt: z.string().datetime().nullable(),
  endsAt: z.string().datetime().nullable(),
});

// TypeScript types derived from Zod schemas
export type RewardDto = z.infer<typeof RewardDtoSchema>;
export type Reward = z.infer<typeof RewardSchema>;
export type RewardRule = z.infer<typeof RewardRuleSchema>;
export type GroupedReward = z.infer<typeof GroupedRewardSchema>;
